import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';

import { PlayerService } from '../../services/player.service';
import { GlobalService } from '../../services/global.service';
import { ShareDialogComponent } from '../share-dialog/share-dialog.component';

@Component({
    selector: 'sd-youtube-dialog',
    templateUrl: './youtube-dialog.component.html',
    styleUrls: ['./youtube-dialog.component.scss']
})

export class YoutubeDialogComponent implements OnInit {

    backdrop: any = true;
    backdropClass: any = 'dialogBackdrop';
    focus: any = false;
    navigationClose: any = true;
    disableClose: any = false;
    maxWidth: any = 'calc(100% - 16px)';

    videoDialogOpened = false;

    constructor(
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<YoutubeDialogComponent>,
        // private eRef: ElementRef,
        private player: PlayerService,
        public global: GlobalService
    ) {
        console.log('data', data);

        this.player.myPlaylist.pause();
        this.player.videoPlaysCount(data.slug);
    }

    shareDialogRef: MatDialogRef<ShareDialogComponent>;

    ngOnInit() {
        const angularthis = this;

        var YTVideo;

        // Loads the IFrame Player API code asynchronously
        function loadScript() {
            if (typeof(window['YT']) == 'undefined' || typeof(window['YT'].Player) == 'undefined') {
                var tag = document.createElement('script');
                tag.id = 'iframe-demo';
                tag.src = 'https://www.youtube.com/iframe_api';
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }
        }

        function onPlayerReady(event) {
            // console.log('player ready', event);
        }

        function onPlayerStateChange(event) {
            // console.log('state change', event);

            if ( event.data == 0 ) {
                YTVideo.stopVideo();
            }
        }

        if ( angularthis.global.isBrowser ) {
            $(document).ready(function() {
                loadScript();

                if ( window['onYouTubeIframeAPIReady'] ) {
                    // console.log('YouTube API is already ready');

                    YTVideo = new window['YT'].Player('YTVideo', {
                        height: '390',
                        width: '640',
                        videoId: angularthis.data.src,
                        playerVars: {'rel': 0, 'showsearch': 0, 'autohide': 2, 'autoplay': 1, 'controls': 1, 'fs': 1, 'loop': 0, 'showinfo': 1, 'color': 'red', 'theme': 'light', 'wmode': 'transparent'},
                        events: {
                            'onReady': onPlayerReady,
                            'onStateChange': onPlayerStateChange
                        }
                    });
                } else {
                    window['onYouTubeIframeAPIReady'] = function() {
                        // console.log('YouTube API Ready');

                        YTVideo = new window['YT'].Player('YTVideo', {
                            height: '390',
                            width: '640',
                            videoId: angularthis.data.src,
                            playerVars: {'rel': 0, 'showsearch': 0, 'autohide': 2, 'autoplay': 1, 'controls': 1, 'fs': 1, 'loop': 0, 'showinfo': 1, 'color': 'red', 'theme': 'light', 'wmode': 'transparent'},
                            events: {
                                'onReady': onPlayerReady,
                                'onStateChange': onPlayerStateChange
                            }
                        });
                    };
                }

                angularthis.videoDialogOpened = true;
            });
        }

       


    }


    // @HostListener('document:click', ['$event'])
    // clickout(event) {
    //     if ( this.global.isBrowser ) {
    //         if ( this.videoDialogOpened && !this.eRef.nativeElement.contains(event.target) ) {
    //             $('#youtubeDialog').addClass('resizeXS');
    //             $('.cdk-global-overlay-wrapper').removeClass('overlayBG');
    //         }
    //     }
    // }

    public isMaximized() {
        if ( this.global.isBrowser ) {
            if ( $('#youtubeDialog').hasClass('resizeXS') ) {
                return false;
            } else {
                return true;
            }
        }

        return true;
    }

    closeDialog() {
        this.global.trackEvent('video-widget', 'PopUp', 'Close');
        this.dialogRef.close();
    }

    public openShareDialog(type, slug, title = '', artist = '', image: any) {
        this.shareDialogRef = this.dialog.open(ShareDialogComponent, {
            data: { type: type, slug: slug, title: title, artist: artist, image: image },
            id: 'shareDialog',
            hasBackdrop: this.backdrop,
            backdropClass: this.backdropClass,
            autoFocus: this.focus,
            closeOnNavigation: this.navigationClose,
            disableClose: this.disableClose,
            maxWidth: this.maxWidth
        });
    }

    toggleYTDialog() {
        if (this.global.isBrowser) {
            $('#youtubeDialog').toggleClass('resizeXS'); $('.cdk-global-overlay-wrapper').toggleClass('overlayBG');
        }
    }
}
